import {HttpClient} from "../../service/httpClient/HttpClient";
import {uploadFile} from "../../service/uploaderService/UploaderService";

export class FormService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getFormList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-forms`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    getFormDetail(formsId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `fund-forms/${formsId}`
            ).then(resolve).catch(reject)
        })
    }

    addNewFormInfo(title, pdfFile, setPdfProgress, setPdfLoadingState, wordFile, setWordProgress, setWordLoadingState) {
        return new Promise(async (resolve, reject) => {
            const forms = await this.handleUpdateFiles(pdfFile, setPdfLoadingState, setPdfProgress, wordFile, setWordLoadingState, setWordProgress, reject);


            this.httpClient.post(
                `fund-forms`,
                {
                    "title": title,
                    "formsIds": forms,
                    "enabled": true
                },
            ).then(resolve).catch(reject)

        })
    }

    disabledForm(formId, title, pdfFileId, wordFileId) {
        const forms = []

        if (pdfFileId && pdfFileId > 0)
            forms.push(pdfFileId)

        if (wordFileId && wordFileId > 0)
            forms.push(wordFileId)


        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `fund-forms/${formId}`,
                {
                    "title": title,
                    "formsIds": forms,
                    "enabled": false
                }
            ).then(resolve).catch(reject)
        })
    }

    updateFormInfo(formId, title, pdfFileId, wordFileId, pdfFile, setPdfProgress, setPdfLoadingState, wordFile, setWordProgress, setWordLoadingState) {

        return new Promise(async (resolve, reject) => {
            const forms = await this.handleUpdateFiles(pdfFile, setPdfLoadingState, setPdfProgress, wordFile, setWordLoadingState, setWordProgress, reject);

            if (!pdfFile)
                forms.push(pdfFileId)

            if (!wordFile)
                forms.push(wordFileId)

            this.httpClient.put(
                `fund-forms/${formId}`,
                {
                    "title": title,
                    "formsIds": forms,
                    "enabled": true
                },
            ).then(resolve).catch(reject)

        })

    }

    async handleUpdateFiles(pdfFile, setPdfLoadingState, setPdfProgress, wordFile, setWordLoadingState, setWordProgress, reject) {
        const forms = []

        try {

            if (pdfFile) {
                setPdfLoadingState(true)
                const pdf = await uploadFile(
                    pdfFile,
                    `management/forms`,
                    setPdfProgress
                )
                setPdfLoadingState(false)

                forms.push(pdf.id)
            }

            if (wordFile) {
                setWordLoadingState(true)
                const word = await uploadFile(
                    wordFile,
                    `management/forms`,
                    setWordProgress,
                )

                setWordLoadingState(false)

                forms.push(word.id)
            }

        } catch (reason) {
            reject(reason)
        }
        return forms;
    }
}